import React from "react";
import Box from '@mui/material/Box';
import CircularProgress,{circularProgressClasses,} from '@mui/material/CircularProgress';


function Loader2(props) {
      
    return(<>
        {props.isloading==="true" &&(
            <Box 
            width='100%'
              display='flex'
              justifyContent='center'
              position= 'fixed'
              top='50%'
              zIndex='tooltip' 
              transform='translate(-50%, -50%)'
              sx={{ opacity:'0.4',
               
               }}>

                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    sx={(theme) => ({
                    color: '#1a90ff',
                    animationDuration: '550ms',
                    // position: 'absolute',
                    left: 0,
                    [`& .${circularProgressClasses.circle}`]: {
                        strokeLinecap: 'round',
                    },
                    ...theme.applyStyles('dark', {
                        color: '#308fe8',
                    }),
                    })}
                    size={40}
                    thickness={4}
                    {...props}
                />
            </Box>
          )}
    </>);
}
export default Loader2;